
import { formatDistance } from 'date-fns'

export default {
  props: ['reviews'],
  methods: {
    dateDistance (reviewDate) {
      return formatDistance(new Date(reviewDate), new Date())
    },
    getUrl (url) {
      return url || 'https://www.trustpilot.com/review/infodiagram.com'
    }
  }
}
